import { useEffect, useState } from 'preact/hooks'
import { io } from "socket.io-client"
import {
  getSession,
} from '../a-portal/resources/session'
import { useAppState } from './appState'


const socket = io(JLINC_A_API.replace("/api", ""), {
  autoConnect: false,
  auth: (cb) => {
    cb({
      token: getSession().sessionId
    })
  },
})

socket.on("connect_error", (err) => {
  console.log(err instanceof Error)
  console.log(err.message)
  console.log(err.data)
})

const callEventListeners = {
  incomingCall: new Set(),
  callResponse: new Set(),
}

export function onIncomingCall(handler) {
  callEventListeners.incomingCall.add(handler)
  return () => { callEventListeners.incomingCall.delete(handler) }
}

export function onCallResponse(handler) {
  callEventListeners.callResponse.add(handler)
  return () => { callEventListeners.callResponse.delete(handler) }
}

socket.on('incomingCall', (data) => {
  console.log('[Socket] incomingCall event received:', data.roomName, 'from:', data.callerIdentity, 'handlers:', callEventListeners.incomingCall.size)
  callEventListeners.incomingCall.forEach(handler => {
    try { handler(data) } catch (e) { console.error('incomingCall handler error:', e) }
  })
})

socket.on('callResponse', (data) => {
  callEventListeners.callResponse.forEach(handler => {
    try { handler(data) } catch (e) { console.error('callResponse handler error:', e) }
  })
})


export { socket }

export function useSocket(){
  const [isConnected, setIsConnected] = useState(socket.connected)
  const {takeAction} = useAppState({}, 'useSocket')

  useEffect(() => {
    function onConnect() {
      setIsConnected(true)
    }

    function onDisconnect() {
      setIsConnected(false)
    }

    socket.on('connect', onConnect)
    socket.on('disconnect', onDisconnect)
    socket.on("new message", function(data) {
      setTimeout(() => {
        takeAction('chat.reflectNewMessage', data)
      }, 100)
    })

    socket.on("new reaction", function(data) {
      console.log('🟠 Socket event received:', data)
      takeAction('chat.reflectNewReaction', data)
    })

    socket.on("edit message", function(data) {
      takeAction('chat.reflectEditedMessage', data.chatMessage)
    })

    socket.on("reply message", function(data) {
      takeAction('chat.loadMessages', data.chatMessage.channelUid)
    })

    socket.on("chatMessagesRead", function(data) {
      setTimeout(() => {
        takeAction('chat.reflectReadMessage', data.chatMessage)
      }, 200)
    })

    socket.on("chatMessageDeleted", function(data) {
      takeAction('chat.reflectDeletedMessage', data.chatMessage)
    })

    socket.on("chatEvents", function(data) {
      takeAction('chat.reflectChatEvents', data.events)
    })

    socket.on("chatMembers", function(data) {
      takeAction('chat.reflectChatMembers', data.events)
    })

    socket.on("newNotification", function(data) {
      takeAction('notifications.reflectNewNotification', data)
    })

    return () => {
      socket.off('connect', onConnect)
      socket.off('disconnect', onDisconnect)
    }
  }, [])

  return [isConnected]
}
